import { Map, List } from 'immutable';
import OnlineHomeworkContent from './model';

import {
  FETCH_ONLINE_HOMEWORK_CONTENT_SUCCESS,
} from './actions';

export default function onlineHomeworkContentReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_ONLINE_HOMEWORK_CONTENT_SUCCESS:
      return addOnlineHomeworkContentToMap(state, action);
    default:
      return state;
  }
}

function addOnlineHomeworkContentToMap(state, { payload, sessionId }) {
  let newState = state;
  newState = newState.set(`${sessionId}`,
      new List(payload.map((activity) =>
        OnlineHomeworkContent.create(activity))));
  return newState;
}



// WEBPACK FOOTER //
// ./data/OnlineHomework/Content/reducer.js